import React from "react";
const Configuration: React.FC = () => <></>;
export default Configuration;
